import { render, staticRenderFns } from "./RevokeMultiChoiceCardDialog.vue?vue&type=template&id=01c9836d&"
import script from "./RevokeMultiChoiceCardDialog.vue?vue&type=script&lang=ts&"
export * from "./RevokeMultiChoiceCardDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RevokeMultiChoiceCardDialog.vue?vue&type=style&index=0&id=01c9836d&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports